import {
  ColDef,
  Column,
  GetContextMenuItemsParams,
} from '@ag-grid-community/core'

/**
 * Function to apply filter on cell
 */
export async function filterOnCell(params: GetContextMenuItemsParams) {
  if (!params.column) return

  const valueToFilter = params.value
  const colId = params.column.getColId()
  const filterType = params.column.getColDef().filter
  const colInstance = params.api.getFilterInstance(colId)

  let filterModel
  if (typeof filterType === 'function') {
    switch (filterType.name) {
      case 'TextFilter':
        filterModel = {
          type: 'equals',
          filterType: 'text',
          filter: valueToFilter,
        }
        break
      case 'NumberFilter':
        filterModel = {
          type: 'equals',
          filterType: 'number',
          filter: valueToFilter ? valueToFilter.toString() : valueToFilter,
        }
        break
    }
  } else {
    switch (filterType) {
      case 'numberFilter':
        filterModel = {
          type: 'equals',
          filterType: 'number',
          filter: valueToFilter ? valueToFilter.toString() : valueToFilter,
        }
        break
      case 'textFilter':
      case 'agTextColumnFilter':
        filterModel = {
          type: 'equals',
          filterType: 'text',
          filter: valueToFilter,
        }
        break
      case 'dateFilter':
        filterModel = {
          type: 'equals',
          filterType: 'date',
          filter: valueToFilter,
        }
        break
      case 'dateTimeFilter':
        filterModel = {
          type: 'equals',
          filterType: 'date',
          filter: valueToFilter,
        }
        break
      case 'agSetColumnFilter':
      case true: {
        const setValue = setFilterValueOf(params, params.column)
        filterModel = {
          filterType: 'set',
          values: Array.isArray(setValue) ? setValue : [setValue],
        }
        break
      }
    }
  }
  colInstance?.setModel(filterModel)
  params.api.onFilterChanged()
}

/**
 * A set filter lists its column's filterValueGetter output, which can differ from the cell value.
 */
function setFilterValueOf(params: GetContextMenuItemsParams, column: Column) {
  const colDef = column.getColDef()
  const { filterValueGetter } = colDef
  const node = params.node
  if (typeof filterValueGetter !== 'function' || !node) {
    return params.value
  }
  const filterValue = filterValueGetter({
    data: node.data,
    node,
    colDef,
    column,
    api: params.api,
    columnApi: params.columnApi,
    context: params.context,
    getValue: (field: string) => params.api.getValue(field, node),
  })
  return isListedBy(colDef, filterValue) ? filterValue : params.value
}

/**
 * A fixed values list can use a different vocabulary than the filterValueGetter.
 */
function isListedBy(colDef: ColDef, value: unknown) {
  const listed = colDef.filterParams?.values
  return !Array.isArray(listed) || listed.some(v => String(v) === String(value))
}
